import { PREVIEW_FINISHED } from '../../action-types/ui/previewFinished';

export const STATE_KEY = 'previewFinished';

export const previewFinished = (state = '', action) => {
  switch (action.type) {
    case PREVIEW_FINISHED: {
      return action.status;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/previewFinished.js